import { render, staticRenderFns } from "./Neighborhood.vue?vue&type=template&id=d0011f32&scoped=true&"
import script from "./Neighborhood.vue?vue&type=script&lang=js&"
export * from "./Neighborhood.vue?vue&type=script&lang=js&"
import style0 from "./Neighborhood.vue?vue&type=style&index=0&id=d0011f32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0011f32",
  null
  
)

export default component.exports